import type { JSX } from 'react';

import * as styles from './DataTableScrollShadow.sty.js';
import { useDataTable } from '../contexts/DataTableContext.js';

/**
 * Renders scroll shadows on the left and right edges of the DataTable
 * to indicate that there is more content to scroll to.
 * The shadows are only displayed if there is overflow in the respective direction
 * and if there are no pinned columns on that side.
 *
 */
export const DataTableScrollShadow = (props: {
  hasOverflowLeft: boolean;
  hasOverflowRight: boolean;
}): JSX.Element | null => {
  const table = useDataTable();
  const { hasOverflowLeft, hasOverflowRight } = props;

  const leftPinnedColumns = table.getLeftVisibleLeafColumns();
  const rightPinnedColumns = table.getRightVisibleLeafColumns();

  const leftScrollShadow =
    hasOverflowLeft && leftPinnedColumns.length === 0 ? (
      <div role="presentation" className={styles.tableEdgeShadow.left} />
    ) : null;

  const rightScrollShadow =
    hasOverflowRight && rightPinnedColumns.length === 0 ? (
      <div role="presentation" className={styles.tableEdgeShadow.right} />
    ) : null;

  return (
    <>
      {leftScrollShadow}
      {rightScrollShadow}
    </>
  );
};
